export default import.meta.ROLLDOWN_FILE_URL_B5NzYNJttwgbrPdaqgh8UQ